import { Button, Checkbox, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShipmentTypeFptModal, ShipmentTypeGptModal } from '@hero/components/modals';
import { PriceBreakdownDropdown } from '@hero/components/molecules';
import { useCreatePriceLabel } from '@hero/hooks';
import { formatCurrency } from '@hero/utils';

import * as S from './style';

export function ProductOptionsByCheckbox({ product, setImages, selectedSkus, setSelectedSkus }) {
  const { t } = useTranslation();
  const { isCAActMustBeApplied } = useCreatePriceLabel(product);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const shipmentType = product?.meta?.shipmentType;
  const isShipmentTypeGPT = shipmentType === 'GPT';

  return (
    <S.AttrListWrapper>
      <Typography variant="body1Bold">{t('configureAvailableAttributes')}</Typography>
      <Typography variant="body2" style={{ marginTop: 4 }} color="gray" emphasis="400">
        {t('configureAvailableAttributesDesc')}
      </Typography>
      <S.OptionList>
        {product?.skus
          .sort((a, b) => b.price - a.price)
          .map(sku => {
            const priceValue = isCAActMustBeApplied ? sku?.priceBreakdown?.display : sku.price;

            return (
              <S.AttrWrapper
                key={sku.code}
                onMouseOver={() => {
                  setImages(sku.images?.[0] ? [sku.images?.[0]] : []);
                }}
              >
                <S.AttrBody
                  onClick={() => {
                    if (selectedSkus?.find(selectedSku => selectedSku.code === sku.code)) {
                      setSelectedSkus(
                        selectedSkus?.filter(selectedSku => selectedSku.code !== sku.code)
                      );
                    } else {
                      setSelectedSkus([...selectedSkus, sku]);
                    }
                  }}
                >
                  <Checkbox
                    key={selectedSkus}
                    checked={!!selectedSkus?.find(selectedSku => selectedSku.code === sku.code)}
                    readOnly
                  />
                  <S.Option as="div" variant="body2">
                    <div dangerouslySetInnerHTML={{ __html: sku.name }} />{' '}
                    <b style={{ fontSize: 12 }}>({sku.code})&nbsp;</b>
                  </S.Option>
                  <S.SKUPrice variant="body2Bold">{formatCurrency(priceValue)}</S.SKUPrice>
                </S.AttrBody>
              </S.AttrWrapper>
            );
          })}

        {isCAActMustBeApplied && (
          <S.FeeBreakdownButtonWrapper>
            <PriceBreakdownDropdown product={product} />
          </S.FeeBreakdownButtonWrapper>
        )}

        {shipmentType && (
          <>
            <S.ProductDetailShipmentType>
              {isShipmentTypeGPT
                ? t('sentByDeliveryPartner')
                : t('designedAndDeliveredByLocalShop')}
              <Button variant="link" onClick={() => setIsModalOpen(true)}>
                {t('learnMore')}
              </Button>
            </S.ProductDetailShipmentType>
            {isModalOpen && isShipmentTypeGPT ? (
              <ShipmentTypeFptModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
            ) : (
              <ShipmentTypeGptModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
            )}
          </>
        )}
      </S.OptionList>
    </S.AttrListWrapper>
  );
}

ProductOptionsByCheckbox.propTypes = {
  product: PropTypes.object,
  setImages: PropTypes.func,
  selectedSkus: PropTypes.array,
  setSelectedSkus: PropTypes.func
};
